<div class="overview-sort">
  <label for="sort-on" i18n>Sort on:</label>
  <div class="custom-select">
    <select
      (ngModelChange)="onChangeActiveSortField($event)"
      [(ngModel)]="activeSortFieldKey"
      id="sort-on"
      >
      @for (sortField of sortFields; track sortField) {
        <option
        [innerHTML]="
          sortField.sortIconHtml
            ? sortField.name + ' ' + sortField.sortIconHtml
            : sortField.name
        "
          [value]="sortField.optionKey"
        ></option>
      }
    </select>
  </div>
</div>
